import {FieldValues, SubmitHandler, UseFormReturn} from 'react-hook-form';
import clsx from 'clsx';
import React, {ReactNode} from 'react';
import {useStickySentinel} from '@common/utils/hooks/sticky-sentinel';
import {Button} from '@common/ui/buttons/button';
import {Trans} from '@common/i18n/trans';
import { downloadFile, useDownloadReport } from '@app_modules/document-requests/reports/requests/use-download-bsa-report';
import { useDownloadPdf } from '@app_modules/requests/use-download-uw-pdf';

interface Props<T extends FieldValues> {
  reportId?: string|number;
  title?: ReactNode;
  subTitle?: ReactNode;
  isLoading?: boolean;
  children: ReactNode;
  actions?: ReactNode;
  backButton?: ReactNode;
  disableSaveWhenNotDirty?: boolean;
  wrapInContainer?: boolean;
}
export function ViewChatDemoLayout<T extends FieldValues>({
  reportId,
  title,
  subTitle,
  children,
  actions,
  backButton,
  isLoading = false,
  disableSaveWhenNotDirty = false,
  wrapInContainer = true,
}: Props<T>) {
  const {isSticky, sentinelRef} = useStickySentinel();
  const downloadReport = useDownloadPdf();

  return (
    <section
    >
      <div ref={sentinelRef} />
      <div
        className={clsx(
          ' top-0 z-10 my-2 transition-shadow md:my-4',
          isSticky && 'bg shadow',
        )}
      >
        <div
          className={clsx(
            'flex items-center gap-24 md:items-start',
            wrapInContainer && ' mx-auto px-10',
          )}
        >
          {backButton}
          <div className="overflow-hidden overflow-ellipsis md:mr-64">
            <h2 className="overflow-hidden overflow-ellipsis whitespace-nowrap text-xl md:text-3xl">
              {title}
            </h2>
            {subTitle && <div className="mt-4">{subTitle}</div>}
          </div>
          <div className="mr-auto"></div>
          {actions}
          {actions}

          {/* <Button
            variant="flat"
            color="primary"
            type="submit"
            onClick={() => {
              downloadReport.mutate({report_id: reportId}, {
                onSuccess: (response) => {
                  const fileName = reportId+'.pdf';
                  downloadFile(fileName, response)
                },
              });
            }}
            disabled={downloadReport.isPending}
          >
            <Trans message="View Report" />

          </Button> */}

          
        </div>
      </div>
      <div
        className={
          wrapInContainer ? ' mx-auto px-10 pb-24' : undefined
        }
      >
        <div className="rounded">{children}</div>
      </div>
    </section>
  );
}
